// What the Unassigned voices list derives from its rows: the voices grouped under the
// recording they were told apart in, in the order the read gave them. Pure.
import type { UnassignedVoice } from '@/services/api/identity-voices'

export interface RecordingGroup {
  documentId: string
  documentName: string | null
  recordedAt: string | null
  voices: UnassignedVoice[]
}

/** One group per recording, recordings in the order their first voice appears. */
export function groupByRecording(voices: readonly UnassignedVoice[]): RecordingGroup[] {
  const groups = new Map<string, RecordingGroup>()
  for (const voice of voices) {
    const group = groups.get(voice.document_id)
    if (group) group.voices.push(voice)
    else
      groups.set(voice.document_id, {
        documentId: voice.document_id,
        documentName: voice.document_name,
        recordedAt: voice.recorded_at,
        voices: [voice],
      })
  }
  return Array.from(groups.values())
}

/** Why a voice has no checkbox to tick: nothing to compare, or not prepared yet. */
export function unassignableReason(voice: UnassignedVoice): 'pending' | 'notAssignable' | null {
  if (voice.assignable) return null
  return voice.matching_status === 'pending' ? 'pending' : 'notAssignable'
}
